import styled from 'styled-components';

export const PerkWrapper = styled.div`
  width: 100%;
  display: flex;
  background-color: #f6f6f6;
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
  &:focus-visible {
    outline: 2px dotted;
    outline-offset: 2px;
  }
`;
export const PerkLeftSection = styled.div`
  width: 135px;
  height: 135px;
  flex: 0 0 135px;
  @media screen and (max-width: 1231px) {
    width: 102px;
    height: 135.77px;
    flex: 0 0 102px;
  }
  @media screen and (max-width: 767px) {
    width: 102px;
    height: 135.77px;
    flex: 0 0 102px;
  }
`;
export const PerkImageSection = styled.div`
  background: url(${(props) => props.$bg});
  width: 100%;
  height: 100%;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
`;

export const PerkHeaderWrapper = styled.div`
  width: 100%;
`;
export const PerkFooterWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-end;
`;

export const PriceWrapper = styled.div`
  width: 100%;
`;

export const PerkGridContainer = styled.div`
  align-items: end;
  //display: grid;
  flex-wrap: wrap;
  gap: 1rem;
  grid-template-columns: repeat(1, 1fr);
  //padding-bottom: 2rem;
  //padding-top: 1.5rem;
  position: relative;
  width: 100%;
  @media screen and (min-width: 768px) {
    gap: 1.5rem;
    grid-template-columns: repeat(2, 1fr);
  }
  @media screen and (min-width: 992px) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

export const PerkRightSection = styled.div`
  width: 100%;
  padding: 12px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const ToggleWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
`;
export const PerkMainContainer = styled.div``;
export const PerkPromoWrapper = styled.div`
  display: flex;
  padding: ${(props) => props.$padding};
  gap: ${(props) => props.$gap || ''};
`;
export const TextWrapper = styled.div`
  //   width: 154px;
  padding-right: 16px;
  p {
    text-decoration: underline;
    text-decoration-offset: 3px;
  }
`;

export const FooterLeftWrapper = styled.div`
  width: 100%;
`;

export const FooterRightWrapper = styled.div``;
